<template>
<div>
  <b-card header="Importações">
    <Grid name="filterGridImportsResults" ref="filterGridImportsResults" v-bind:url="url" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
export default {
  name: 'Imports',
  components: {
    Grid
  },
  data() {
    return {
      preload: [],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'updated_at': {
          type: 'date'
        },
        'file_rows': {
          type: 'number'
        },
        'imported_rows': {
          type: 'number'
        }
      },
      url: 'import/results/',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '180px'
      }, {
        width: '160px',
        field: 'import_id',
        title: 'ID Importação'
      }, {
        field: 'tablename',
        title: 'Tabela',
        width: '200px'
      }, {
        field: 'file_rows',
        title: 'Linhas Ficheiro',
        width: '200px'
      }, {
        field: 'rows_imported',
        title: 'Linhas Importadas',
        width: '200px'
      }, {
        field: 'hasErrors',
        title: 'Erros',
        width: '200px',
        values: [{
          value: 1,
          text: 'Sim'
        }, {
          value: 0,
          text: 'Não'
        }]
      }, {
        field: 'updated_at',
        title: 'Atualizado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      var route = router.resolve({
        name: 'tables.import-results-view',
        params: {
          id: this.$route.params.id,
          detailId: item.id
        }
      })
      return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-search"></i> ver</a>'
    }
  },
  created() {
    this.url = this.url + this.$route.params.id
  }
}
</script>



// WEBPACK FOOTER //
// imports_results.vue?42330996